import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { IClientTransferSetting } from "./Table";
import { Fetch } from "../../shared/Fetch";

interface IProps{
    singleData: IClientTransferSetting,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema=yup.object({
    setting_Head: yup.string().required("Setting Head is required"),
    number: yup.number().nullable().typeError('Only number is allowed'),
    weightage: yup.number().nullable().typeError('Only number is allowed'),
});


export const Form = (props: IProps) => {
    const [saveDis,setSaveDis] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IClientTransferSetting>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const saveToDB = async (body: IClientTransferSetting) => {
        const method = props.singleData.setting_Head != "" ? "PUT" : "POST";
        const message = props.singleData.setting_Head !="" ? "Updated Successfully" : "Added Successfully";
        
        const response = await Fetch("tbl_Client_Transfer_Setting", method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onSubmit=(data: IClientTransferSetting)=>{
        setSaveDis(true);
        saveToDB(data);
    }

    const onHide=()=>{
        props.setReload(!props.reload);
        props.hideDialog();
    }

    useEffect(()=>{
        reset(props.singleData);
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Client Transfer Setting" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={3} required label="Setting Head:" control={control} name="setting_Head" error={errors.setting_Head?.message} />
                <JVInput column={3} label="Number:" control={control} name="number" error={errors.number?.message} />
                <JVInput column={3} label="Weightage(%):" control={control} name="weightage" error={errors.weightage?.message} />
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}